import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-jahirat-pratinidiwise-jamareport',
  templateUrl: './jahirat-pratinidiwise-jamareport.component.html',
  styleUrl: './jahirat-pratinidiwise-jamareport.component.scss'
})
export class JahiratPratinidiwiseJamareportComponent {




  constructor(
    private dialogRef: MatDialogRef<JahiratPratinidiwiseJamareportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
  ) {
  }


  advtFormBeans: any = []
  reportType: any
  startDate: any
  endDate: any
  repName: any
  offRepName: any
  advtName: any
  issueDates: any
  issueDates1: any

  PaymentReceiptRegister = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
    rep_name: new FormControl(),
    off_rep_name: new FormControl(),
    issuename: new FormControl(),
    issueDates: new FormControl(),
  });
  startDate_contract: any;
  enddate_contract: any;
  advtVBTotal: number = 0;


  monthlyTotals: { [key: string]: number } = {};
monthlyDngeeTotals: { [key: string]: number } = {};
grandTotal: number = 0;
grandTotalDngee: number = 0;
  // PaymentadvtOffInDTotal3: number = 0;
  // PaymentadvtOffInDTotal: number = 0;
  ngOnInit(): void {
    let repname: any = this.data['repName'];

    if (repname != "") {
      repname = repname;
    }

    this.reportType = this.data['reportType'];
    this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
    this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
    this.repName = this.data['repName'];
    this.offRepName = this.data['offRepName'];
    this.advtName = this.data['name'];
    this.issueDates = this.data.issueDates;
    this.issueDates1 = this.data['issue_date'];

    const req: any = {
      "rep_name": repname,
      "start_date": this.startDate,
      "end_date": this.endDate,
      "off_rep_name": this.offRepName,
      "issue_name": "",
      "issue_date": this.issueDates
    };

    // 1. Generate dynamic headers before/during the service call
    if (this.startDate && this.endDate) {
      this.generateDynamicHeaders(this.startDate, this.endDate);
    }

    this.service.getAdvtjamaPratinidi(req).subscribe((data: any) => {
      // Ensure data is the array of offices containing rep_data
      this.advtFormBeans = data;

      // Calculate global total if needed
      this.advtVBTotal = data.reduce((acc, office) => acc + (parseFloat(office.total) || 0), 0);

      this.calculateOfficeMonthlyTotals();

      this.cdr.detectChanges();
    });
  }

  exportExcel(fileName): void {
    console.log('Export function called with fileName:', fileName);

    let element = document.getElementById('print-section');
    console.log('Element found:', element);

    if (!element) {
      console.error('Element with ID "print-section" not found in DOM');
      return;
    }

    try {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      console.log('Worksheet created:', ws);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, fileName + '.xlsx');
      console.log('File should be downloaded');
    } catch (error) {
      console.error('Error during export:', error);
    }
  }

  selectedMonths: any[] = [];

  // generateDynamicHeaders(start: string, end: string) {
  //   const startDate = new Date(start);
  //   const endDate = new Date(end);
  //   const months = [];
  //   const monthNames = ["जानेवारी", "फेब्रुवारी", "मार्च", "एप्रिल", "मे", "जून", "जुलै", "ऑगस्ट", "सप्टेंबर", "ऑक्टोबर", "नोव्हेंबर", "डिसेंबर"];

  //   let current = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
  //   while (current <= endDate) {
  //     months.push({
  //       name: monthNames[current.getMonth()],
  //       // CONVERT TO STRING to match your JSON keys "4", "5", etc.
  //       index: (current.getMonth() + 1).toString()
  //     });
  //     current.setMonth(current.getMonth() + 1);
  //   }
  //   this.selectedMonths = months;
  // }


  formatCurrency(value: number | null | undefined): string {

    if (!value || value === 0) return '';
    return value.toString();
  }


  reportYearRange: string = '';

  toDevanagariNumber(num: number): string {
    const devanagariDigits = ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'];
    return num.toString().split('').map(d => devanagariDigits[+d]).join('');
  }

  generateDynamicHeaders(start: string, end: string) {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const months = [];
    const monthNames = ["जानेवारी", "फेब्रुवारी", "मार्च", "एप्रिल", "मे", "जून", "जुलै", "ऑगस्ट", "सप्टेंबर", "ऑक्टोबर", "नोव्हेंबर", "डिसेंबर"];

    let current = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    while (current <= endDate) {
      months.push({
        name: monthNames[current.getMonth()],
        index: (current.getMonth() + 1).toString()
      });
      current.setMonth(current.getMonth() + 1);
    }
    this.selectedMonths = months;

    // ✅ This is the part that was missing in your old method
    const startYear = startDate.getFullYear();
    const endYear = endDate.getFullYear();

    this.reportYearRange = startYear === endYear
      ? this.toDevanagariNumber(startYear)
      : `${this.toDevanagariNumber(startYear)}-${this.toDevanagariNumber(endYear)}`;
  }


  //  printPageA4Portrait(): void {
  //   const printSection = document.getElementById('print-section');
  //   if (!printSection) return;

  //   const win = window.open('', '', 'width=800,height=1100');
  //   if (!win) return;

  //   win.document.write(`
  //     <html>
  //     <head>
  //       <meta charset="UTF-8">
  //       <style>
  //         @page { 
  //           size: A4 portrait; 
  //           margin: 10mm 8mm 10mm 8mm; 
  //         }

  //         /* Enable color printing */
  //         @media print {
  //           * {
  //             -webkit-print-color-adjust: exact !important;
  //             print-color-adjust: exact !important;
  //             color-adjust: exact !important;
  //           }
  //         }

  //         body { 
  //           font-family: Arial, sans-serif; 
  //           margin: 0; 
  //           padding: 0; 
  //           font-size: 10px;
  //         }

  //         table { 
  //           border-collapse: collapse; 
  //           width: 100%; 
  //           page-break-inside: auto;
  //         }

  //         tr { 
  //           page-break-inside: avoid; 
  //           page-break-after: auto; 
  //         }

  //         thead { 
  //           display: table-header-group; 
  //         }

  //         tfoot { 
  //           display: table-footer-group; 
  //         }

  //         th, td {
  //           border: 1px solid #000;
  //           padding: 3px 4px;
  //           font-size: 9px;
  //           text-align: center;
  //           white-space: nowrap;
  //         }

  //         .header-title {
  //           font-size: 12px;
  //           font-weight: bold;
  //           padding: 6px;
  //         }

  //         .input-header-cell {
  //           font-size: 10px;
  //           font-weight: bold;
  //         }

  //         .user-name {
  //           font-size: 11px;
  //           font-weight: bold;
  //         }

  //         .vertical-header {
  //           writing-mode: vertical-rl;
  //           text-orientation: mixed;
  //           font-weight: bold;
  //           font-size: 10px;
  //         }

  //         .text-left { 
  //           text-align: left; 
  //           padding-left: 6px; 
  //         }

  //         .bg-grey { 
  //           background-color: #f0f0f0; 
  //         }

  //         .category-total-row { 
  //           font-weight: bold; 
  //         }

  //         .section-row {
  //           font-weight: bold;
  //           text-align: left;
  //           padding-left: 8px;
  //         }

  //         /* Hide input fields borders in print */
  //         input {
  //           border: none;
  //           background: transparent;
  //           text-align: center;
  //           width: 100%;
  //           font-size: 9px;
  //         }

  //         /* Specific background colors for sections */
  //         .main-header {
  //           background-color: #e3f2fd !important;
  //         }

  //         .sub-header {
  //           background-color: #fff9c4 !important;
  //         }

  //         .column-labels {
  //           background-color: #e1f5fe !important;
  //           font-weight: bold;
  //         }
  //       </style>
  //     </head>
  //     <body>
  //       ${printSection.outerHTML}
  //       <script>
  //         setTimeout(() => { window.print(); window.close(); }, 500);
  //       </script>
  //     </body>
  //     </html>
  //   `);

  //   win.document.close();
  // }

//   printPageA4Landscape(): void {
//     const printSection = document.getElementById('print-section');
//     if (!printSection) return;
//     const printWindow = window.open('', '', 'width=1400,height=900');
//     if (!printWindow) return;

//     printWindow.document.write(`
// <html>
//   <head>
//     <title>व्यवसाय अहवाल</title>
//     <style>
//       @page { size: A4 landscape; margin: 6mm; }
//       * {
//         -webkit-print-color-adjust: exact !important;
//         print-color-adjust: exact !important;
//       }
//       body {
//         font-size: 1px;
//         font-weight: bold;
//       }
//       table { border-collapse: collapse; width: 100%; }
//       th, td {
//         border: 1px solid #000;
//         padding: 4px;
//         font-size: 12px;
//         font-weight: bold;
//         text-align: center;
//       }
//       .amount-cell { text-align: right; }
//       .total-row { font-weight: bold; background: #f0f0f0; }
//     </style>
//   </head>
//   <body>${printSection.outerHTML}</body>
// </html>
// `);
//     printWindow.document.close();
//     setTimeout(() => {
//       printWindow.print();
//       printWindow.close();
//     }, 500);
//   }

// printPageA3Landscape(): void {
//   const printSection = document.getElementById('print-section');
//   if (!printSection) return;
//   const printWindow = window.open('', '', 'width=1800,height=1000');
//   if (!printWindow) return;

//   printWindow.document.write(`
// <html>
//   <head>
//     <title>व्यवसाय अहवाल</title>
//     <style>
//       @page {
//         size: A3 landscape;
//         margin: 6mm;
//       }

//       * {
//         -webkit-print-color-adjust: exact !important;
//         print-color-adjust: exact !important;
//         box-sizing: border-box;
//       }

//       html, body {
//         margin: 0;
//         padding: 0;
//         width: 100%;
//         font-family: Arial, sans-serif;
//       }

//       #scale-wrapper {
//         transform-origin: top left;
//         /* Do not set fixed width here — JS will handle it */
//       }

//       table {
//         border-collapse: collapse;
//         width: 100%;
//         table-layout: auto;
//       }

//       th, td {
//         border: 1px solid #000;
//         padding: 2px 5px;
//         font-size: 10px;
//         font-weight: bold;
//         text-align: center;
//         white-space: nowrap;
//       }

//       /* अ.क्र. column */
//       th:nth-child(1), td:nth-child(1) {
//         min-width: 25px;
//         width: 25px;
//       }

//       /* प्रतिनिधी column */
//       th:nth-child(2), td:nth-child(2) {
//         min-width: 140px;
//         text-align: left;
//       }

//       /* ठिकाण column */
//       th:nth-child(3), td:nth-child(3) {
//         min-width: 80px;
//         text-align: left;
//       }

//       /* Amount columns */
//       th:nth-child(n+4), td:nth-child(n+4) {
//         min-width: 70px;
//         text-align: right;
//       }

//       .amount-cell { text-align: right; }
//       .total-row   { font-weight: bold; background: #f0f0f0; }

//       @media print {
//         html, body {
//           width: 100%;
//           height: 100%;
//           overflow: hidden;
//         }
//         #scale-wrapper {
//           transform: scale(var(--print-scale, 1));
//           transform-origin: top left;
//         }
//       }
//     </style>
//   </head>
//   <body>
//     <div id="scale-wrapper">
//       ${printSection.outerHTML}
//     </div>
//     <script>
//       window.onload = function () {
//         var wrapper = document.getElementById('scale-wrapper');

//         // A3 landscape minus 6mm margins on each side
//         // Width:  420mm - 12mm = 408mm => at 96dpi = 1542px
//         // Height: 297mm - 12mm = 285mm => at 96dpi = 1077px
//         var pageWidthPx  = 1542;
//         var pageHeightPx = 1077;

//         var contentWidth  = wrapper.scrollWidth;
//         var contentHeight = wrapper.scrollHeight;

//         // Calculate scale to fit BOTH width and height — use the smaller scale
//         var scaleX = pageWidthPx  / contentWidth;
//         var scaleY = pageHeightPx / contentHeight;
//         var scale  = Math.min(scaleX, scaleY);

//         // Only scale down, never scale up
//         if (scale < 1) {
//           wrapper.style.setProperty('--print-scale', scale);
//           wrapper.style.transform        = 'scale(' + scale + ')';
//           wrapper.style.transformOrigin  = 'top left';

//           // Set body size to scaled dimensions so no overflow/second page
//           document.body.style.width    = (contentWidth  * scale) + 'px';
//           document.body.style.height   = (contentHeight * scale) + 'px';
//           document.body.style.overflow = 'hidden';
//         }

//         setTimeout(function () {
//           window.print();
//           window.close();
//         }, 700);
//       };
//     <\/script>
//   </body>
// </html>
//   `);

//   printWindow.document.close();
// }

printPageA3Landscape(): void {
  const printSection = document.getElementById('print-section');
  if (!printSection) return;
  const printWindow = window.open('', '', 'width=1800,height=1000');
  if (!printWindow) return;

  printWindow.document.write(`
<html>
  <head>
    <title>व्यवसाय अहवाल</title>
    <style>
      @page {
        size: A3 landscape;
        margin: 6mm;
      }

      * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        box-sizing: border-box;
      }

      html, body {
        margin: 0;
        padding: 0;
        font-family: Arial, sans-serif;
      }

      #scale-wrapper {
        transform-origin: top left;
      }

      table {
        border-collapse: collapse;
        width: 100%;
        table-layout: auto;
      }

      th, td {
        border: 1px solid #000;
        padding: 2px 5px;
        font-size: 10px;
        font-weight: bold;
        text-align: center;
        white-space: nowrap;
      }

      th:nth-child(1), td:nth-child(1) {
        min-width: 25px;
        width: 25px;
      }

      th:nth-child(2), td:nth-child(2) {
        min-width: 140px;
        text-align: left;
      }

      th:nth-child(3), td:nth-child(3) {
        min-width: 80px;
        text-align: left;
      }

      th:nth-child(n+4), td:nth-child(n+4) {
        min-width: 70px;
        text-align: right;
      }

      .amount-cell { text-align: right; }
      .total-row   { font-weight: bold; background: #f0f0f0; }
    </style>
  </head>
  <body>
    <div id="scale-wrapper">
      ${printSection.outerHTML}
    </div>
    <script>
      window.onload = function () {
        var wrapper = document.getElementById('scale-wrapper');

        // A3 landscape minus 6mm margins on each side
        var pageWidthPx  = 1542;
        var pageHeightPx = 1077;

        var contentWidth  = wrapper.scrollWidth;
        var contentHeight = wrapper.scrollHeight;

        var scaleX = pageWidthPx  / contentWidth;
        var scaleY = pageHeightPx / contentHeight;
        var scale  = Math.min(scaleX, scaleY, 1); // never scale up

        // ✅ zoom reflows layout, so nothing gets clipped by the print engine
        wrapper.style.zoom = scale;

        setTimeout(function () {
          window.print();
          window.close();
        }, 700);
      };
    <\/script>
  </body>
</html>
  `);

  printWindow.document.close();
}




  // calculateOfficeMonthlyTotals() {
  //   for (let office of this.advtFormBeans) {
  //     for (let m of this.selectedMonths) {
  //       let monthTotal = 0;
  //       let monthDngeeTotal = 0;

  //       for (let rep of office.rep_data) {
  //         monthTotal += parseFloat(rep[m.index]) || 0;
  //         monthDngeeTotal += parseFloat(rep['dngee_' + m.index]) || 0;
  //       }

  //       // Store back into office object so HTML can read it
  //       office['total_' + m.index] = monthTotal || '';
  //       office['total_dngee_' + m.index] = monthDngeeTotal || '';
  //     }

  //     // Also recalculate overall office total from rep_data
  //     office.total = office.rep_data.reduce((sum, rep) => sum + (parseFloat(rep.rcv_amt) || 0), 0) || '';
  //     office.total_dngee = office.rep_data.reduce((sum, rep) => sum + (parseFloat(rep.rcv_dngee) || 0), 0) || '';
  //   }
  // }

  calculateOfficeMonthlyTotals() {
  for (let office of this.advtFormBeans) {
    for (let m of this.selectedMonths) {
      let monthTotal = 0;
      let monthDngeeTotal = 0;

      for (let rep of office.rep_data) {
        monthTotal += parseFloat(rep[m.index]) || 0;
        monthDngeeTotal += parseFloat(rep['dngee_' + m.index]) || 0;
      }

      office['total_' + m.index] = monthTotal || '';
      office['total_dngee_' + m.index] = monthDngeeTotal || '';
    }

    office.total = office.rep_data.reduce((sum, rep) => sum + (parseFloat(rep.rcv_amt) || 0), 0) || '';
    office.total_dngee = office.rep_data.reduce((sum, rep) => sum + (parseFloat(rep.rcv_dngee) || 0), 0) || '';
  }

  // ✅ NEW: Aggregate across ALL offices for the tfoot (grand total) row
  this.monthlyTotals = {};
  this.monthlyDngeeTotals = {};
  this.grandTotal = 0;
  this.grandTotalDngee = 0;

  for (let m of this.selectedMonths) {
    let monthSum = 0;
    let monthDngeeSum = 0;

    for (let office of this.advtFormBeans) {
      monthSum += Number(office['total_' + m.index]) || 0;
      monthDngeeSum += Number(office['total_dngee_' + m.index]) || 0;
    }

    this.monthlyTotals[m.index] = monthSum;
    this.monthlyDngeeTotals[m.index] = monthDngeeSum;
  }

  this.grandTotal = this.advtFormBeans.reduce((sum, office) => sum + (Number(office.total) || 0), 0);
  this.grandTotalDngee = this.advtFormBeans.reduce((sum, office) => sum + (Number(office.total_dngee) || 0), 0);
}


}
